<template>
  <div class="container">
    <!-- <div id="container" :style="{ height: '800px', width: '100%' }"></div> -->
    <div id="tree" :style="{ zoom: vz + '%' }">
      <TreeChart :json="treeData" :class="{ landscape: 0 }" />
    </div>
    <div class="control">
      <div class="item">
        <div class="fuhao" @click="shrink">-</div>
        <div class="hint">缩小</div>
      </div>
      <div class="item">
        <div class="fuhao" @click="enlarge">+</div>
        <div class="hint">放大</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getUserTree } from "@api/user";
import TreeChart from "@components/moblie/TreeChart";
import G6 from "@antv/g6";
export default {
  name: "UserTree",
  components: {
    TreeChart
  },
  data: function() {
    return {
      tree: [],
      treeData: {},
      vw: 0,
      vh: 0,
      top: 0,
      left: 0,
      vz: 100
    };
  },
  watch: {},
  created() {
    this.vw = 400 + "px";
    this.vh = 800 + "px";
    this.vz = 100;
  },
  async mounted() {
    // wx14881618967245 1234567
    let data = await getUserTree();
    this.tree = data.data;
    // let treeChildren = [];
    this.getTree();
    this.showChart();
  },
  methods: {
    getTree() {
      let data2 = [];
      this.tree.forEach((i, index) => {
        let data3 = [];
        this.tree.forEach((j, index2) => {
          if (j.spread_uid == i.uid && index !== index2) {
            data3.push({
              name: j.nickname + " " + j.uid,
              image_url: j.avatar,
              spread_uid: j.spread_uid,
              uid: j.uid
            });
          }
        });
        data2.push({
          name: i.nickname + " " + i.uid,
          image_url: i.avatar,
          spread_uid: i.spread_uid,
          uid: i.uid,
          children: data3
        });
      });
      data2 = data2.filter(d => {
        return d.children.length > 0;
      });
      let long = data2.length;
      while (long > 1) {
        let last = data2.pop();
        let sonIndex = data2.findIndex(m => {
          return m.uid == last.spread_uid;
        });
        let grandSonIndex = data2[sonIndex].children.findIndex(n => {
          return n.uid == last.uid;
        });
        data2[sonIndex].children[grandSonIndex] = last;
        // data2[long - 1].children;
        long--;
      }
      this.treeData = data2[0];
      this.treeData = JSON.stringify(data2[0]);
      this.treeData = JSON.parse(this.treeData);
    },
    showChart() {
      const data = this.treeData;
      const container = document.getElementById("container");
      if (container) {
        const width = container.clientWidth;
        const height = container.clientHeight;
        const graph = new G6.TreeGraph({
          // 图的DOM 容器，可以传入该 DOM 的 id 或者直接传入容器的 HTML 节点对象。
          container: container,
          width: width,
          height: height,
          // 设置画布的模式 包含default 模式和 edit 模式
          modes: {
            // default 模式中包含点击选中节点行为和拖拽画布行为
            default: [
              {
                type: "collapse-expand",
                trigger: "click"
              },
              // 拖拽画布 和 缩放画布
              "drag-canvas",
              "zoom-canvas"
            ]
          },
          // 默认的节点设置
          defaultNode: {
            //节点的大小
            size: 34,
            // 指定边连入节点的连接点的位置
            anchorPoints: [[0, 0.5], [1, 0.5]],
            // 节点样式
            style: {
              fill: "#c6e5ff",
              stroke: "#5B8FF9"
            }
          },
          // 默认的配置
          defaultEdge: {
            type: "cubic-horizontal",
            style: {
              stroke: "#A3B1BF"
            }
          },
          layout: {
            type: "compactBox",
            direction: "TB",
            // 指定节点 ID
            getId: function getId(d) {
              return d.id;
            },
            // 指定节点高度
            getHeight: function getHeight() {
              return 16;
            },
            //指定节点宽度
            getWidth: function getWidth() {
              return 16;
            },
            // 指定节点之间的垂直间距
            getVGap: function getVGap() {
              return 100;
            },
            // 指定节点之间的水平间距
            getHGap: function getHGap() {
              return 60;
            }
          }
        });

        // 为不同节点进行不同的配置 必须在 render 之前调用
        graph.node(function(node) {
          return {
            style: {
              // fill: node.depth == 2 && node.status ? "#c1422b" : "#c6e5ff",
              stroke: node.depth == 2 && node.status ? "#c1422b" : "#6b9bfa",
              fill: "url(" + node.image_url + ")"
            },
            //String 类型。标签文本的文字内容
            label: node.name,
            labelCfg: {
              // 文本的偏移
              offset: 10,
              // 文本相对于节点的位置
              position:
                node.children && node.children.length > 0 ? "left" : "right",
              //文本样式
              style: {
                fill: node.depth == 2 && node.status ? "#c1422b" : "#2c3e50"
              }
            }
          };
        });
        //初始化数据
        graph.data(data);
        //渲染视图
        graph.render();
        //让画布内容适应视口
        graph.fitView();
      }
    },
    shrink() {
      if (this.vz > 10) {
        this.vz = this.vz - 10;
      }
    },
    enlarge() {
      this.vz = this.vz + 10;
    }
  }
};
</script>
<style scoped>
.container {
  padding: 100px 20px 0 20px;
  overflow: auto;
  background-color: #fff;
  height: 100%;
}
.control {
  position: fixed;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  padding: 8px;
  background-color: rgb(244, 73, 57);
  color: #fff;
  box-shadow: 0 0 2px 2px rgb(184, 182, 182);
  border-radius: 10px;
  z-index: 99;
}
.control .item {
  font-size: 8px;
  margin: 0 8px;
  width: 30px;
}
.fuhao {
  font-size: 26px;
  width: 100%;
  text-align: center;
}
.hint {
  width: 100%;
  text-align: center;
}
</style>
